<template>
<div
  class="partner-wrapper"
  >
  <div
    class="partner-content"
    >
    <img v-for="(partner, index) in partners"
      :key="index"
      :src="partner.url"
      class="partner"
      >
  </div>

  <img :src="rideInnovation" class="fullImage">

  <!-- <p>info@rideq.se</p>
  <p>© RideQ AB 2019</p> -->
</div>
</template>
<script>
export default {
  data () {
    return {
      partners: [{
        url: require('@/assets/aesuana.png')
      }, {
        url: require('@/assets/almi.png')
      }, {
        url: require('@/assets/chalmersVentures.png')
      }, {
        url: require('@/assets/wearSustain.png')
      }, {
        url: require('@/assets/vinnova.png')
      }, {
        url: require('@/assets/vsg.png')
      }],
      rideInnovation: require('@/assets/rideInnovation.jpg')
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .partner-wrapper {
    height: auto;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
  }

  .partner-content {
    width: 100%;
    max-width: @width-max;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    height: auto;

    img {
      margin: 10px 10px;
    }
  }

  .partner {
    height: 40px;
    margin: 20px 0px;
  }

  .fullImage {
    display: block;
    width: 100%;
    max-width: @width-max;
    margin-top: 50px;
    margin-bottom: 50px;
    height: auto;
    max-height: 500px;
  }
</style>
